import styled from 'styled-components';
import DateRangeFilter from './component';

export default styled(DateRangeFilter)`
  position: relative;

  .input {
    height: 32px;
    border: 1px solid var(--grey500);
    width: 100%;
    color: var(--grey900);
    display: flex;
    align-items: center;
    padding: 0 16px 0 8px;
    background-color: white;
    position: relative;

    span {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &:before {
      position: absolute;
      content: '';
      display: block;
      width: 0;
      height: 0;
      right: 8px;
      border-style: solid;
      border-width: 4px 3px 0 3px;
      border-color: var(--grey500) transparent transparent transparent;
    }

    &__opened {
      &:before {
        border-width: 0 3px 4px 3px;
        border-color: transparent transparent var(--grey500) transparent;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .tooltip {
    background-color: white;
    padding: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    width: 520px;
    margin: 0;
    opacity: 1;
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 2;

    &:before,
    &:after {
      display: none;
    }
  }

  .buttons-container {
    display: flex;
    &__right {
      justify-content: flex-end;
    }
    .me-button {
      margin-right: 8px;
    }
  }

  .calendar {
    margin: 16px 0;
  }

  .Selectable {
    font-size: 1.2rem;
    .DayPicker-wrapper {
      padding-bottom: 0;
      outline: none;
    }
    .DayPicker-NavButton {
      top: 0;
      right: 0;
    }
    .DayPicker-Month {
      margin: 0;
      & + .DayPicker-Month {
        margin-left: 16px;
      }
    }
    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      background-color: var(--primary100);
      color: var(--grey900);
    }
    .DayPicker-Day {
      border-radius: 0;
      padding: 0.8em;
      outline: none;
    }
    .DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
      background-color: var(--primary200);
    }
    .DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
      background-color: var(--primary200);
    }
  }
`;
